import { ApiPromocode } from '../../../../services/eaptekaApi/methods/cartGet/types';

export function serializePromocodeFromApi(
  data: ApiPromocode
) {
  return {
    status: data.status,
    value: data.value,
    notificationTitle: data.notificationTitle,
    notificationText: data.notificationText
  };
}
